import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './modal-confir-reenvio-soportes.component.html'
})
export class ModalConfirReenvioComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalConfirReenvioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { mensaje: string }
  ) {}

  cerrar() {
    this.dialogRef.close();
  }
}